
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M237 38.6c-8.4 1.8-13.7 3.7-23.5 8.8-17.3 8.9-30.7 22.7-39.5 41-5.9 12.1-7.8 19.2-8.7 30.8l-.6 8.8H144c-11.3 0-23.3.5-26.6 1.1-13.3 2.4-27.7 12.2-35.4 24.1-7.1 10.9-7.2 11.2-17.5 115-5.2 52.6-9.5 98.4-9.5 101.6 0 8.9 2.6 21.9 6.4 32.8 12.3 34.3 40.3 59.7 76.6 69.6l8.5 2.3h219l9.9-2.8c39.6-11 69-41.3 78.6-80.8 4.1-16.9 4-18.8-5.9-118.4-5.1-50.6-9.8-95.6-10.6-99.9-3.4-19.1-16.3-34.2-35.3-41.4-6.4-2.5-7.9-2.6-30.8-3l-24.1-.4-.6-8.6c-.9-11.6-2.9-18.7-8.7-30.8-12.5-25.9-35.7-44.2-63.2-49.8-9.5-2-28.8-2-37.8 0m30.3 35.9c23 4.8 40.4 24.1 43.2 47.7l.7 5.8H200.8l.7-5.8c2.2-18.6 13.8-35.2 30.2-43.2 11.8-5.7 23.2-7.2 35.6-4.5m127.3 94.1c2.1 1.6 4.5 4.6 5.5 6.5 1.3 2.6 3.8 24.9 10.9 94.9 5.1 50.3 9.2 94.7 9.2 98.7-.4 25.6-16.3 50.4-39.7 61.9-17.2 8.4-8.9 7.9-124.5 7.9-110.3 0-106.4.2-119.5-5.2-25.6-10.6-44.4-37.6-44.6-63.8-.1-8.9 17.8-188.9 19.1-193.1 1-3.1 5.8-8.2 9.5-10.2 1.4-.8 39.5-1.1 136.2-.9l134.1.2z"}}),_c('path',{attrs:{"d":"M175.4 202.9c-2.3 1-5.4 3.6-7 5.7-2.6 3.3-2.9 4.7-3.3 12-1.1 27.1 15.1 57.7 39.4 74.4 7 4.8 19.9 10.6 29.5 13.1 11.8 3.2 32.8 3.2 44.5 0 9.8-2.6 22.8-8.7 30.9-14.5 23.2-16.6 38.6-46.6 37.5-73-.4-7.3-.7-8.7-3.3-12-5.7-7.6-16.2-9.5-24.2-4.6-5.2 3.3-7.6 8-8.5 17.4-2.1 21-12.4 37.3-28.9 46.1-25.9 13.5-56.1 5.6-72.2-18.9-4.7-7.3-7.6-16.4-8.7-27.2-1-9.4-3.3-14.1-8.6-17.4-4.9-3-12.1-3.5-17.1-1.1"}})])
          )
        }
      }
    